import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canListCategories } from "@/helpers/permissions";
import { canManageCategories } from "@/modules/ticket-categories/permissions";

import { CreateTicketCategoryPage } from "./pages/CreateTicketCategoryPage";
import { EditTicketCategoryPage } from "./pages/EditTicketCategoryPage";
import { TicketCategoryOverviewPage } from "./pages/TicketCategoryOverviewPage";
import { ticketCategoriesRoutes } from "./routes";

export const ticketCategoriesRoute = [
  {
    path: ticketCategoriesRoutes.list,
    element: (
      <RequireAuth permission={canListCategories}>
        <TicketCategoryOverviewPage />
      </RequireAuth>
    ),
  },
  {
    path: ticketCategoriesRoutes.create,
    element: (
      <RequireAuth permission={canManageCategories}>
        <CreateTicketCategoryPage />
      </RequireAuth>
    ),
  },
  {
    path: ticketCategoriesRoutes.edit,
    element: (
      <RequireAuth permission={canManageCategories}>
        <EditTicketCategoryPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
